
import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Globe } from "lucide-react";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AnalysisHistory, getScanHistory, formatDateTime } from '@/utils/analysisHelpers';

interface ScanHistoryProps {
  recentScans?: AnalysisHistory[];
  formatDateTime?: (dateString: string) => string;
  saveToFile?: (content: string, filename: string) => void;
}

export const ScanHistory: React.FC<ScanHistoryProps> = ({
  recentScans: propScans,
  formatDateTime: propFormatDateTime
}) => {
  const { t } = useTranslation();
  const [scans, setScans] = useState<AnalysisHistory[]>([]);
  
  useEffect(() => {
    if (propScans) {
      setScans(propScans);
    } else {
      // Prop olarak geçilmediğinde localStorage'dan yükle
      const history = getScanHistory();
      setScans(history);
    }
  }, [propScans]);

  // Tarih formatlama fonksiyonunu kullan (prop veya varsayılan)
  const formatDate = propFormatDateTime || formatDateTime;

  return (
    <Card className="p-6">
      <CardHeader className="p-0 mb-4">
        <CardTitle>{t('recentSites.title')}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {scans.length === 0 ? (
          <p className="text-muted-foreground">{t('analysis.noSiteScanned')}</p>
        ) : (
          <div className="space-y-2">
            {scans.map((scan, index) => (
              <div key={index} className="flex justify-between items-center p-2 border-b last:border-0">
                <div className="flex items-center">
                  <Globe className="h-4 w-4 mr-2 text-primary" />
                  <Link to={`/analysis/${scan.domain}`} className="text-blue-600 hover:underline">
                    {scan.domain}
                  </Link>
                </div>
                <div className="flex items-center space-x-4">
                  <span className="text-sm text-muted-foreground">{scan.urlCount} URL</span>
                  <span className="text-sm text-muted-foreground">{formatDate(scan.date)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
